// ABOUTME: Local-time date helpers. `Date.toISOString().slice(0, 10)` always
// emits the UTC date — west of UTC after sunset that is "tomorrow", which
// breaks date-picker defaults (issue #562). Use these helpers when you need
// the user's local calendar date.

/**
 * Returns the calendar date in the local timezone as `YYYY-MM-DD`.
 * Defaults to "now" when no Date is supplied.
 *
 * Unlike `d.toISOString().slice(0, 10)`, this respects the host timezone, so
 * a user in `America/New_York` at 10pm sees today's date, not tomorrow's.
 */
export function todayLocalDateString(d: Date = new Date()): string {
  const y = d.getFullYear()
  const m = String(d.getMonth() + 1).padStart(2, '0')
  const day = String(d.getDate()).padStart(2, '0')
  return `${y}-${m}-${day}`
}
